if (!customElements.get('jc-coups-de-coeur')) {
  customElements.define(
    'jc-coups-de-coeur',
    class JCCoupsDeCoeur extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.jc-coups-de-coeur__track');
        this.cards = this.querySelectorAll('.jc-coups-de-coeur__card');
        this.prevBtn = this.querySelector('[data-carousel-prev]');
        this.nextBtn = this.querySelector('[data-carousel-next]');

        this.prevBtn?.addEventListener('click', () => this.scrollByCard(-1));
        this.nextBtn?.addEventListener('click', () => this.scrollByCard(1));
      }

      scrollByCard(direction) {
        const card = this.cards[0];
        if (!card || !this.track) return;

        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        this.track.scrollBy({ left: direction * (card.offsetWidth + gap), behavior: 'smooth' });
      }
    }
  );
}
